module.exports = __webpack_public_path__ + "static/img/jp3.92d7590d.png";